import { render, staticRenderFns } from "./TopTen.vue?vue&type=template&id=24a7b6cc&scoped=true&"
import script from "./TopTen.vue?vue&type=script&lang=js&"
export * from "./TopTen.vue?vue&type=script&lang=js&"
import style0 from "./TopTen.vue?vue&type=style&index=0&id=24a7b6cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24a7b6cc",
  null
  
)

export default component.exports